import { z } from 'zod/v4';

const responseDateSchema = z.union([z.string(), z.date()]);

/** One of a product's identifiers (`style_codes`), archived ones included. */
export const StyleCodeSchema = z.object({
  codeId: z.string(),
  codeValue: z.string(),
});

export type StyleCode = z.infer<typeof StyleCodeSchema>;

/**
 * A product at any level (style, variant or SKU) as its `styles` row reads, with
 * the comma-separated columns split into lists and the 0/1 flags as booleans.
 */
export const StyleRecordSchema = z.object({
  id: z.string(),
  forCompanyId: z.string(),
  name: z.string(),
  description: z.string().nullable(),
  gender: z.string().nullable(),
  styleLevelId: z.string(),
  styleTypeId: z.string(),
  /** `style`, `variant` or `sku`; the oldest rows hold none and read as `style`. */
  productLevel: z.string(),
  brands: z.array(z.string()),
  departments: z.array(z.string()),
  seasons: z.array(z.string()),
  collections: z.array(z.string()),
  claimIntentions: z.array(z.string()),
  customProperties: z.array(z.string()),
  suppliers: z.array(z.string()),
  mainSupplier: z.string().nullable(),
  vendors: z.array(z.string()),
  imagesFileIds: z.array(z.string()),
  isComponent: z.boolean(),
  isArchived: z.boolean(),
  isStoryActive: z.boolean(),
  createdAt: responseDateSchema,
  updatedAt: responseDateSchema.nullable(),
  createdByImpersonateId: z.string().nullable(),
  createdByUserId: z.string().nullable(),
  createdByCompanyId: z.string().nullable(),
  createdByApiKeyId: z.string().nullable(),
  createdByApiKeyLabel: z.string().nullable(),
  updatedByImpersonateId: z.string().nullable(),
  updatedByUserId: z.string().nullable(),
  updatedByCompanyId: z.string().nullable(),
  updatedByApiKeyId: z.string().nullable(),
  updatedByApiKeyLabel: z.string().nullable(),
});

export type StyleRecord = z.infer<typeof StyleRecordSchema>;
